import React from 'react';

import {
  dateRangeMedWithZoneOffset,
  isDateTimeInFuture,
} from '../../helpers/dates';
import { ILibraryMeetingPlaceDictionary } from '@/lib/fragments/libraryMeetingPlaceDictionary';
import { FavouriteButton } from '../ui/favourite-button/favourite-button';
import Link from 'next/link';
import Flame from '@assets/icons/Flame-listing.svg';
import ImageWrapper from '../image-wrapper/Image-wrapper';
import LinkWrapper from '../link-wrapper/link-wrapper';

interface EventCardProps {
  card: any;
  cardIndex: number;
  dictionary?: ILibraryMeetingPlaceDictionary;
  node_locale: string;
  parentSlug?: string;
  fixedWidth?: boolean;
}

export const EventCard = ({
  card,
  cardIndex,
  dictionary,
  node_locale,
  parentSlug,
  fixedWidth = false,
}: EventCardProps) => {
  const aspectRatio =
    (card?.tenant?.logo?.width && card?.tenant?.logo?.height) ||
    (card?.tenant?.brand?.logo?.width && card?.tenant?.brand?.logo?.height)
      ? parseInt(
          card?.tenant?.logo?.width || card?.tenant?.brand?.logo?.width,
        ) /
        parseInt(
          card?.tenant?.logo?.height || card?.tenant?.brand?.logo?.height,
        )
      : undefined;

  const isNearlySquare =
    typeof aspectRatio === 'number' && Math.abs(aspectRatio - 1) < 0.1;

  return (
    <div className="relative">
      <LinkWrapper
        data={{
          name: card?.name,
          sys: { locale: node_locale },
          slug: card.slug,
          urlSubDirectory: parentSlug,
        }}
        key={card?.id}
        className={`group flex cursor-pointer flex-col overflow-hidden rounded-xl focus:outline focus:outline-3 focus:outline-offset-3 focus:outline-text-light bg-background-primary-light transition-all lg:hover:bg-background-secondary ${fixedWidth && 'w-[316px]'}`}
      >
        <div className="z-10">
          {(card?.tenant?.logo || card?.tenant?.brand?.logo) && (
            <ImageWrapper
              url={card?.tenant?.logo?.url || card?.tenant?.brand?.logo?.url}
              alt={
                card?.tenant?.logo?.description
                  ? card?.tenant?.logo?.description
                  : 'alt text not found'
              }
              className="!absolute top-5 left-5 w-16 h-16 bg-brand-white rounded-[12px] flex items-center justify-center"
              imgClassName={
                isNearlySquare
                  ? '!object-contain rounded-[12px] border border-brand-grey-2'
                  : '!object-contain'
              }
              width={
                card?.tenant?.logo?.width || card?.tenant?.brand?.logo?.width
                  ? parseInt(
                      card?.tenant?.logo?.width ||
                        card?.tenant?.brand?.logo?.width,
                    )
                  : undefined
              }
              height={
                card?.tenant?.logo?.height
                  ? parseInt(
                      card?.tenant?.logo?.height ||
                        card?.tenant?.brand?.logo?.height,
                    )
                  : undefined
              }
            />
          )}
        </div>
        {card?.mediaField?.jsonBynderAsset?.originalUrl && (
          <div className="image-box relative rounded-xl overflow-hidden bg-background-primary-light transition-all lg:hover:bg-background-secondary">
            <img
              src={
                card?.mediaField?.jsonBynderAsset?.originalUrl + '?fm=avif&q=50'
              }
              alt={card?.mediaField?.altText || 'alt text not found'}
              className="absolute inset-0 h-full w-full object-cover"
            />
          </div>
        )}

        <div className="flex min-h-[210px] flex-1 flex-col flex-wrap rounded-b-xl bg-background-primary-light px-6 py-5 transition-all duration-200 lg:group-hover:bg-background-secondary">
          <div className="mb-auto">
            {card?.slots && (
              <div className="font-sans text-bodym text-neutral-grey-700 font-bold flex items-center gap-2">
                {card?.slots?.variant == 'Today' ? (
                  <>
                    <Flame /> {dictionary?.today ?? 'Today'}
                  </>
                ) : (
                  dictionary?.nextEvent + ':' + ' ' + card?.slots?.date
                )}
              </div>
            )}
            <div className="mb-1 min-h-[20px] text-bodym text-text-light">
              {dateRangeMedWithZoneOffset(
                card?.startDate.toString(),
                card?.endDate.toString(),
                node_locale,
              )}
            </div>

            <h2
              className={`mb-2 mt-2 line-clamp-3 min-h-[42px] overflow-hidden text-ellipsis font-title text-headingm text-text-default transition-all duration-200 ease-in-out
          `}
            >
              {card?.name}
            </h2>
            <div className="flex flex-wrap gap-2">
              {card?.endDate &&
                !isDateTimeInFuture(card?.endDate.toString(), '') && (
                  <span className="flex-shrink-0 rounded-[4px] border-2 border-brand-red-2 bg-brand-red-1 px-2 text-bodyxs font-bold text-text-sticker-red">
                    {dictionary?.pastEvent}
                  </span>
                )}
              {card?.eventTypesCollection &&
                card?.endDate &&
                isDateTimeInFuture(card?.endDate.toString(), '') &&
                // card?.eventTypes?.filter(Boolean)?.map((eventType, key) => (
                [...(card?.eventTypesCollection?.items?.filter(Boolean) ?? [])]
                  .sort((a, b) => {
                    if (a?.name === 'Livli Family') return -1;
                    if (b?.name === 'Livli Family') return 1;
                    return 0;
                  })
                  .map((eventType, key) => (
                    <span
                      key={key}
                      className={`flex-shrink-0 rounded-[4px] border-2  bg-background-primary-light px-2 text-bodyxs font-bold text-text-default ${eventType?.name == 'Livli Family' ? 'border-brand-yellow-2' : 'border-neutral-grey-200'}`}
                    >
                      {eventType?.name}
                    </span>
                  ))}
            </div>
          </div>
        </div>
      </LinkWrapper>
      <FavouriteButton
        id={card?.sys?.id ?? ''}
        type="event"
        className="absolute top-5 right-5 z-[20px] h-12 w-12"
        iconclass="h-6 w-6"
        name={card?.name}
      />
    </div>
  );
};
